<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_v"></a>Contents</h1>
<h2 class="toc1"><a href="#/xhtml/05_Introduction">Introduction</a></h2>
<h2 class="toc1a"><a href="#/xhtml/06_Chapter1"><span class="tocpada">1.</span> The City of Brass</a></h2>
<h2 class="toc1a"><a href="#/xhtml/08_Chapter2"><span class="tocpada">2.</span> South Wales Strife (1): Newport</a></h2>
<h2 class="toc1a"><span href="#/xhtml/09_Chapter3" title="Link target outside of Sample"><span class="tocpada">3.</span> South Wales Strife (2): Tonypandy</span></h2>
<h2 class="toc1a"><span href="#/xhtml/10_Chapter4" title="Link target outside of Sample"><span class="tocpada">4.</span> Cutting off ‘this stream of madness’</span></h2>
<h2 class="toc1a"><span href="#/xhtml/11_Chapter5" title="Link target outside of Sample"><span class="tocpada">5.</span> Crime, Punishment, and the ‘Prisoners’ Friend’</span></h2>
<h2 class="toc1a"><span href="#/xhtml/13_Chapter6" title="Link target outside of Sample"><span class="tocpada">6.</span> Mrs Pankhurst’s Army of Amazons</span></h2>
<h2 class="toc1a"><span href="#/xhtml/15_Chapter7" title="Link target outside of Sample"><span class="tocpada">7.</span> A Whiff of Cordite</span></h2>
<h2 class="toc1a"><span href="#/xhtml/16_Chapter8" title="Link target outside of Sample"><span class="tocpada">8.</span> ‘a dim spectre of revolution’</span></h2>
<h2 class="toc1a"><span href="#/xhtml/18_Chapter9" title="Link target outside of Sample"><span class="tocpada">9.</span> As Dead as Queen Anne</span></h2>
<h2 class="toc1a"><span href="#/xhtml/20_Chapter10" title="Link target outside of Sample"><span class="tocpad">10.</span> ‘Home Secretaries never do have an easy time’</span></h2>
<h2 class="toc1"><span href="#/xhtml/21_Notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc1"><span href="#/xhtml/26_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?3a3083d4